/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { TargetingStrategy } from '@/commons/data';
import { cn } from '@/utils';

const getTargetingStrategyLabel = (targetingStrategy: TargetingStrategy): string => {
    switch (targetingStrategy) {
        case 'xpath':
            return 'xpath';
        case 'datatestid':
            return 'data-testid';
        case 'arialabel':
            return 'aria-label';
        case 'css':
            return 'css';
        case 'playwright':
            return 'playwright';
        default:
            return 'unknown';
    }
};

export const TargetingStrategyBadge = ({
    targetingStrategy,
    className,
}: {
    targetingStrategy?: TargetingStrategy;
    className?: string;
}) => {
    if (!targetingStrategy || targetingStrategy === 'ai') return null;
    return (
        <pre className={cn('text-xs rounded border text-purple-600 inline px-1', className)}>
            :{getTargetingStrategyLabel(targetingStrategy)}
        </pre>
    );
};
